package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class SignUpUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(
        name: String,
        studioName: String,
        specialty: String,
        email: String,
        pass: String
    ): Result<Unit> {
        if (name.isBlank() || email.isBlank() || pass.isBlank()) {
            return Result.failure(IllegalArgumentException("Preencha seu nome, e-mail e senha."))
        }
        if (pass.length < 6) {
            return Result.failure(IllegalArgumentException("A senha deve ter pelo menos 6 caracteres."))
        }
        return authRepository.signUp(
            name = name.trim(),
            studioName = studioName.trim(),
            specialty = specialty,
            email = email.trim(),
            pass = pass
        )
    }
}
